<template>
  <div class="contacts-wrapper">
    <div class="title">Контакты</div>

    <div class="info">
      <span>Украина, г. Харьков, Салтовское Шоссе 43</span>
      <span>+38 (057) 719-52-29</span>
      <span>+38 (057) 717-81-12</span>
      <span>+38 (057) 720-20-88</span>
    </div>

    <div class="form-data">
      <div class="form">
        <div class="main">
          <MtForm v-on:send="sendFeedBack($event)"></MtForm>
        </div>
        <div class="other">
          <div class="text">
            <span>Если хотите стать нашим партнером, переходите по ссылке <a href="https://dclink.ua/catalog/brand/mikrotik/">DC Link</a>.</span>
            <span>Мы всегда открыты для сотрудничества.</span>
          </div>
        </div>
      </div>
    </div>
    <MtModal v-if="isModalShown" v-on:close="isModalShown = false">
      <span slot="modal-title">Сообщение</span>
      <div slot="modal-message">
        <span>Ваше сообщение было отправлено на рассмотрение менеджеру.</span>
        <br>
        <span>С вами свяжутся в течении дня.</span>
      </div>
    </MtModal>
    <MtModal v-if="isErrorModalShown" v-on:close="isErrorModalShown = false">
      <span slot="modal-title">Сообщение</span>
      <div slot="modal-message">
        <span>Ошибка при отправке форма, проверьте правильность заполнения.</span>
      </div>
    </MtModal>
  </div>
</template>

<script>
import MtForm from '../MtForm/MtForm'
import MtModal from '../MtModal/MtModal'
export default {
  name: 'Contacts',
  components: { MtForm, MtModal },
  data () {
    return {
      isModalShown: Boolean,
      isErrorModalShown: Boolean
    }
  },
  created () {
    this.isModalShown = false
    this.isErrorModalShown = false
  },
  methods: {
    sendFeedBack (feedbackData) {
      this.$store.dispatch('sendFeedBack', feedbackData).then(response => {
        if (response && response.data.success) {
          this.isModalShown = true
        }
      }).catch(err => {
        if (err.status === 422) {
          this.isErrorModalShown = true
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../vars";

  .contacts-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-size: 24px;
      font-weight: bold;
      padding: 15px 0 30px 0;
    }
    .info {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      padding-bottom: 30px;
      position: relative;
      margin-bottom: 30px;
      &:after {
        content: '';
        position: absolute;
        height: 1px;
        width: 110%;
        background-color: $btn-c;
        bottom: 0;
        left: -5%;
      }
      span {
        padding: 5px 0;
      }
    }
    .form {
      display: flex;
      flex-direction: column;
      align-items: center;
      .other {
        width: 100%;
        margin-top: 10px;
        position: relative;
        .text {
          font-size: 12px;
          display: flex;
          padding: 40px 20px 20px 20px;
          flex-direction: column;
          align-items: flex-start;
          span {
            padding: 4px 0;
            text-align: left;
          }
          a {
            color: $btn-c;
            &:visited {
              color: $btn-c;
            }
          }
        }
      }
      .buttons {
        padding-top: 10px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        padding-bottom: 30px;
        position: relative;
        .contacts-btn {
          width: 40px;
          height: 40px;
          background-color: $btn-c;
          border: 1px solid $btn-c;
          padding: 10px;
          border-radius: 50%;
          cursor: pointer;
          svg {
            height: 100%;
            width: 100%;
            fill: #FFF;
          }
        }
      }
      .main {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
      }
      .fields {
        width: 250px;
        display: flex;
        flex-direction: column;
        .contacts-field {
          border: 1px solid #dedede;
          background-color: #FFF;
          border-radius: 5px;
          padding: 5px 7px;
          margin-bottom: 10px;
          font-size: 12px;
          box-sizing: border-box;
          &.txta {
            font-family: 'Avenir', Helvetica, Arial, sans-serif;
            min-width: 250px;
            max-width: 250px;
            min-height: 70px;
            max-height: 300px;
          }
        }
      }
      .goods-card {
        width: 200px;
        .image {
          background-color: #FFF;
          border-radius: 10px;
          box-shadow: 0 2px 8px 4px #eaeaea;
          height: 100px;
          width: 100px;
          margin-bottom: 10px;
          overflow: hidden;
          position: relative;
          img {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 0;
            max-width: 130%;
            max-height: 110%;
          }
        }
        .info {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          flex: 1;
          .category-name {
            font-weight: bold;
            font-size: 14px;
          }
          .brand-name, .model, .features {
            font-size: 12px;
            text-align: left;
          }
        }
      }
    }
  }
  @media screen and (max-width: 450px) {
    .contacts-wrapper {
      .form-data {
        .form {
          .main {
            .fields {
              width: 100%;
            }
          }
        }
      }
    }
  }
</style>
